import { createSlice } from '@reduxjs/toolkit';
import { createComment, getAllComment } from './thunks';
import { act } from '@testing-library/react';
import { HouseKeysCommentsState } from './state';

// Initial state for Redux store:
export const initialStateHousekeyComments: HouseKeysCommentsState = {
  housekey_id: null,
  comments: {
    total: 0,
    data: [],
    paginate: {
      current_page: 1,
      items: 0,
      pages: 1,
    },
    success: false,
  },
  loading: false,
};

const housekeyCommentsSlice = createSlice({
  name: 'housekey_comments',
  initialState: initialStateHousekeyComments, // Define initial state
  reducers: {
    setComments: (state: any, action: any) => {
      state.housekeys = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllComment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllComment.fulfilled, (state, action) => {
      state.comments = action.payload.response;
      state.housekey_id = action.payload.housekey_id;
      state.loading = false;
    });
    builder.addCase(createComment.fulfilled, (state, action) => {
      if (action.payload.success) {
        state.comments.data = [action.payload.comment, ...state.comments.data];
        state.comments.total = state.comments.total + 1;
      }
    });
  },
});

// Export actions generated by "createSlice()":
export const { setComments: setHousekeys } = housekeyCommentsSlice.actions;

// Export reducer generated by "createSlice()":
export default housekeyCommentsSlice.reducer;
